import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';
import { getAllSubcategories, getAllTeams } from '../../../redux/api/userMgt';
import { getTeamLeadAssignedCases } from '../../../redux/api/cases';

const TeamLeadAssignedCases = ({ user }) => {
    const [processing, setProcessing] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [subCategories, setSubCategories] = useState([]);
    const [records, setRecords] = useState([]);
    const [officers, setOfficers] = useState([]);
    const [teams, setTeams] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [searches, setSearches] = useState({});

    const init = async (start = 0, length = user.paginationSize) => {
        try {
            setProcessing(true);
            const res = await getTeamLeadAssignedCases({ start, length, searches });
            const resTeams = await getAllTeams();
            const resp = await getAllSubcategories();
            setSubCategories(resp?.resultObject || []);
            setRecords(records?.length < start ? res?.resultObject?.dataTableResponse?.data || [] : records.concat(res?.resultObject?.dataTableResponse?.data || []));

            setOfficers(res?.resultObject?.relationshipOfficers || []);
            setTeams(resTeams?.resultObject || []);
            setPaginationData({
                start,
                length,
                total: res?.resultObject?.recordsTotal,
                totalFiltered: res?.resultObject?.recordsFiltered,
            });
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const exportData = async () => {
        try {
            const resp = await getTeamLeadAssignedCases({ searches }, true);
            enqueueSnackbar(resp?.message || 'Your report is being processed, kindly check the reports page for progress');
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const search = async ({ skip = 0, length = 50, ...searches }) => {
        try {
            const res = await getTeamLeadAssignedCases({ skip, length, searches });
            if (res?.statusCode == '000') {
                setRecords(res?.resultObject?.data || []);
                setSearches(searches);
                if (res?.resultObject?.data?.length == 0) {
                    enqueueSnackbar('No result found for search parameters', {
                        variant: 'error',
                    });
                }
            } else {
                enqueueSnackbar(res?.message || 'An error occurred', {
                    variant: 'info',
                });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        init();
    }, [user.paginationSize]);

    return (
        <PageContainer pageTitle="Team Lead Assigned Cases" processing={processing}>
            <CaseTable
                cases={records}
                showPendingActionsBtn={false}
                showAssignBtn={false}
                showAssignFooterBtn={false}
                showCloseCaseBtn={false}
                showDeEscalateCaseBtn={false}
                showEscalateCaseBtn={false}
                showResolveCaseBtn={false}
                showReOpenFooterBtn={false}
                showReOpenCaseBtn={false}
                showReAssignFooterBtn
                relationshipOfficers={officers}
                showRecategorizeCaseBtn
                exportFunction={exportData}
                subCategories={subCategories}
                searchFunction={search}
                initFunction={init}
            />
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(TeamLeadAssignedCases);
